import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { BodyMassSource, BranchID, MainTitle, MemoCategoryKey, ORG_TYPE, OrderSource, OrgID, RoleType, SoapType, StoreID, SurveyType } from 'src/types';
import { getBranchInfoFromBranchID } from '.';
import { commonSettings } from './commonSettings';
import { doctorListByBranch, getDoctorList } from './doctors';
import { SOAP_KINDS } from './soap';
var AllClinicBranchList = [BranchID.Genesis, BranchID.Lumez, BranchID.LumezGenesis, BranchID.Cymbal, BranchID.Cymbalxinlin, BranchID.GenesisKH, BranchID.GenesisHC];
var AllConsultingBranchList = [BranchID.Cofit, BranchID.FCLab];
var commonProviderList = ['護理', '藥局', '運動營養諮詢', '其他'];
var defaultMainMenuFunctions = [MainTitle.diagnosis, MainTitle.timeline, MainTitle.bloodSugar, MainTitle.clientQuestionnaire, MainTitle.bodyMass, MainTitle.ordersList];
var clinicMainMenuFunctions = [MainTitle.diagnosis, MainTitle.timeline, MainTitle.bloodSugar, MainTitle.clientQuestionnaire, MainTitle.bodyMass, MainTitle.phalanx, MainTitle.inspectionReport, MainTitle.report3D, MainTitle.abdominalUltrasound, MainTitle.uploadFile, MainTitle.ordersList];
var cymbalMainMenuFunctions = [MainTitle.diagnosis, MainTitle.timeline, MainTitle.bloodSugar, MainTitle.clientQuestionnaire, MainTitle.bodyMass, MainTitle.inspectionReport, MainTitle.abdominalUltrasound, MainTitle.uploadFile, MainTitle.ordersList];
var DefaultBranchSetting = {
  IS_CHINA_SITE: process.env.NEXT_PUBLIC_ENVIRONMENT === 'china',
  BOOKING_SOURCE_TYPE: 'SimplyBook',
  APP_NAME: 'pro_app',
  APP_SOURCE: 'cofit',
  MAX_IDENTITY_LENGTH: 10,
  RECORD_NUMBER_PREFIX_FORMAT: '0 + YYMMDD',
  SITE_WISE_ENABLE_SENTRY: true,
  ENABLE_BOOKING_CREATE: false,
  HIDE_SUMMARIZE_BUTTON: false,
  USE_ALIYUN: false,
  COUNTRY: 'tw'
};
export var DefaultClinic = _objectSpread(_objectSpread({}, DefaultBranchSetting), {}, {
  ORG_TYPE: ORG_TYPE.CLINIC,
  SURVEY_ID_LIST: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID, SurveyType.SUPPLEMENT_SURVEY_ID, SurveyType.W2_FEEDBACK_SURVEY_ID, SurveyType.W5_FEEDBACK_SURVEY_ID],
  MEMO_CATEGORY_LIST: [MemoCategoryKey.booking_note, MemoCategoryKey.return_appointment_info_handover, MemoCategoryKey.client_info_detail, MemoCategoryKey.feedback_from_satisfactory_survey, MemoCategoryKey.personalized_supplement_assistant],
  BODYMASS_INIT_TYPE: BodyMassSource.genesis,
  ENABLE_SEARCH_USERS: true,
  ENABLE_IMPORT_INBODY_DONGLE_DATA: false,
  ENABLE_PRESETGROUP: true,
  ENABLE_MODULE_PHARMACY: true,
  ENABLE_MODULE_STOCK: true,
  ENABLE_MODULE_CGREPORT: true,
  ENABLE_MODULE_CLIENT_PROFILE: true,
  ENABLE_MODULE_INFO_MANAGEMENT: true,
  ENABLE_MODULE_MEASUREMENT_MANAGEMENT: true,
  ENABLE_DISPLAY_LINK_TO_POS: true,
  ENABLE_BOOKING_PRINCIPAL_COLUMN_FILTER: false,
  ENABLE_BOOKING_PRINCIPAL_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_SERVICE_NAME_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_LINE_STATUS: false,
  ENABLE_BOOKING_PROVIDER: false,
  ENABLE_BOOKING_VIDEO_CALL: false,
  ENABLE_BOOKING_EDIT: true,

  /** @deprecated not use */
  ENABLE_BOOKING_PROVIDER_FILTER_CREATABLE: true,
  ENABLE_SURVEY_SHORT_NAME: false,
  ENABLE_FORMAT_CHATROOM_NAME_ON_PERSONAL_ROOM: false,
  ENABLE_SHOW_ANALYSIS_GUIDE: false,

  /** @deprecated use `SOAP_TYPES` instead */
  SOAP_KINDS: [SOAP_KINDS.CLINIC],
  MAIN_MENU_FUNCTIONS: clinicMainMenuFunctions,
  SOAP_RESPONSIBLER: RoleType.CLINIC_DOCTOR_ROLE,
  ALLOW_FETCH_SOAP_BRANCHES: AllClinicBranchList,
  SOAP_TYPES: [SoapType.flc_first],
  ORDER_SOURCES: [OrderSource.his],
  VISIBLE_STORE_IDS: []
});
export var DefaultConsult = _objectSpread(_objectSpread({}, DefaultBranchSetting), {}, {
  ORG_TYPE: ORG_TYPE.CONSULT,
  SURVEY_ID_LIST: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID, SurveyType.W2_FEEDBACK_SURVEY_ID, SurveyType.W5_FEEDBACK_SURVEY_ID, SurveyType.ADVANCE_PLAN_SURVEY_ID, SurveyType.ONE_ON_ONE_CONSULTING_SATISFACTION_SURVEY_ID, SurveyType.FOLLOW_UP_FEEDBACK_SURVEY_ID, SurveyType.SUPPLEMENT_SURVEY_ID, SurveyType.SUPPLEMENT_SATISFACTION_SURVEY_ID, SurveyType.SUPPLEMENT_RETURN_SURVEY_ID, SurveyType.SUPPLEMENT_FOLLOW_UP_SATISFACTION_SURVEY_ID, SurveyType.SUPPLEMENT_FEEDBACK_SURVEY_ID, SurveyType.W8_FIRST_SURVEY_ID, SurveyType.W8_SUBSEQUENT_SURVEY_ID, SurveyType.ADCT_SURVEY_ID],
  MEMO_CATEGORY_LIST: [MemoCategoryKey.booking_note, MemoCategoryKey.return_appointment_info_handover, MemoCategoryKey.client_info_detail, MemoCategoryKey.feedback_from_satisfactory_survey, MemoCategoryKey.personalized_supplement_assistant, MemoCategoryKey.one_on_one_consultation, MemoCategoryKey.personalized_supplement_consultation],
  BODYMASS_INIT_TYPE: BodyMassSource.all,
  ENABLE_SEARCH_USERS: false,
  ENABLE_IMPORT_INBODY_DONGLE_DATA: false,
  ENABLE_PRESETGROUP: false,
  ENABLE_MODULE_PHARMACY: false,
  ENABLE_MODULE_STOCK: false,
  ENABLE_MODULE_CGREPORT: false,
  ENABLE_MODULE_CLIENT_PROFILE: true,
  ENABLE_MODULE_INFO_MANAGEMENT: false,
  ENABLE_MODULE_MEASUREMENT_MANAGEMENT: true,
  ENABLE_DISPLAY_LINK_TO_POS: true,
  ENABLE_BOOKING_PRINCIPAL_COLUMN_FILTER: true,
  ENABLE_BOOKING_PRINCIPAL_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_SERVICE_NAME_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_LINE_STATUS: true,
  ENABLE_BOOKING_PROVIDER: true,
  ENABLE_BOOKING_VIDEO_CALL: true,
  ENABLE_BOOKING_EDIT: false,

  /** @deprecated not use */
  ENABLE_BOOKING_PROVIDER_FILTER_CREATABLE: true,
  ENABLE_SURVEY_SHORT_NAME: true,
  ENABLE_FORMAT_CHATROOM_NAME_ON_PERSONAL_ROOM: true,
  ENABLE_SHOW_ANALYSIS_GUIDE: true,

  /** @deprecated use `SOAP_TYPES` instead */
  SOAP_KINDS: [SOAP_KINDS.RD],
  MAIN_MENU_FUNCTIONS: defaultMainMenuFunctions,
  SOAP_RESPONSIBLER: RoleType.CLINIC_DIETICIAN_ROLE,
  ALLOW_FETCH_SOAP_BRANCHES: AllConsultingBranchList,
  SOAP_TYPES: [SoapType.NUTRITIONAL_CONSULTATION, SoapType.NUTRITIONAL_CONSULTATION_FOLLOW_UP, SoapType.NUTRITIONAL_SUPPLEMENT, SoapType.NUTRITIONAL_SUPPLEMENT_FOLLOW_UP],
  ORDER_SOURCES: [OrderSource.his],
  VISIBLE_STORE_IDS: []
}); // clinic

export var GenesisEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.Genesis,
  BRANCH_ID: BranchID.Genesis,
  BRANCH_CODE: '4dKgw9VpAvbt',
  BOOKING_SOURCE_NAMES: [].concat(_toConsumableArray(!commonSettings.isProductionEnv ? commonSettings.STAGING_BOOKING_SOURCE_NAMES : []), ['simplybook_genesisclinic']),
  SUB_DOMAINS: ['genesis', 'go', 'genesis-staging'],
  HEAD_TITLE: '台北初日診所',
  BANNER_TITLE: '台北初日診所',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Genesis]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', 'CGM', '抽血', '注射', '點滴', '拿藥', '運動營養諮詢'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/genesis_staging_logo.png' : '/genesis_logo.png',
  MAIN_MENU_FUNCTIONS: [MainTitle.therapy].concat(clinicMainMenuFunctions),
  CLINIC_INFO: {
    name: '初日診所',
    code: '3501109685',
    address: '台北市中山區民生東路2段163號3樓',
    phone: '02-25075661',
    region: '台北',
    director: '宋晏仁'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Genesis], 'tw'),
  PHARMACY_INFO: {
    name: '初日診所',
    address: '台北市中山區民生東路2段163號3樓',
    phone: '02-25075661',
    pharmacists: [{
      name: '葉媛媛',
      doctor_ids: [5070, 8028] // 宋晏仁, 許芷瑜

    }, {
      name: '李汶瑄',
      doctor_ids: [7358, 10360] // 周建安, 陳威龍

    }]
  },
  SOAP_TYPES: DefaultClinic.SOAP_TYPES.concat([SoapType.PSYCHOLOGICAL_COUNSELING, SoapType.CLINIC_NUTRITIONAL_COUNSELING]),
  ORDER_SOURCES: [].concat(_toConsumableArray(DefaultClinic.ORDER_SOURCES), [OrderSource.pos]),
  VISIBLE_STORE_IDS: [StoreID.Cofit, StoreID.Genesis],
  STORE_ID: StoreID.Genesis,
  ENABLE_BOOKING_VIDEO_CALL: true
});
/**
 * 初日民生與台北初日用同一個 Branch，此資訊只是為了區分用藥清單裡面的診所與藥局資訊
 */

export var MINSHENG_GENESIS_CLINIC_INFO = {
  name: '初日民生診所',
  address: '台北市中山區民生東路2段163號4樓',
  doctor_user_id: [6627, // 鄧雯心
  10553, // 王律婷
  7338, // 李唐越
  8377 // 魏士航
  ],
  pharmacists: [{
    name: '彭郁婷',
    doctor_ids: [6627, 10553, 7338, 8377] // 鄧雯心, 王律婷, 李唐越, 魏士航

  }]
};
export var LumezEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.Lumez,
  BRANCH_ID: BranchID.Lumez,
  BRANCH_CODE: 'Khr3kYes2C7O',
  BOOKING_SOURCE_NAMES: ['simplybook_lumez'],
  SUB_DOMAINS: ['lumez', 'lumez-staging'],
  HEAD_TITLE: '小宙初日南屯',
  BANNER_TITLE: '小宙醫學',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Lumez]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', '抽血'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/lumez_staging_logo.png' : '/lumez_logo.png',
  CLINIC_INFO: {
    name: '小宙醫學',
    code: '3503281840',
    address: '台中市南屯區干城街328號4樓之2',
    phone: '04-22510325',
    region: '南屯',
    director: '吳榛槿'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Lumez], 'tw'),
  PHARMACY_INFO: {
    pharmacist: '',
    name: '澄光人文藥局',
    address: '台中市南屯區干城街305號',
    phone: '04-22530303'
  }
});
export var CymbalEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.Cymbal,
  BRANCH_ID: BranchID.Cymbal,
  BRANCH_CODE: 'SSv4a7K1nVvC',
  BOOKING_SOURCE_NAMES: ['simplybook_genesiscliniccymbalmed'],
  SUB_DOMAINS: ['cymbal', 'cymbal-staging'],
  BANNER_TITLE: '信誠門診',
  HEAD_TITLE: '信誠',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Cymbal]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', '抽血'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/cymbal_logo.png' : '/cymbal_logo.png',
  ENABLE_IMPORT_INBODY_DONGLE_DATA: true,
  ENABLE_MODULE_PHARMACY: false,
  ENABLE_MODULE_STOCK: false,
  ENABLE_MODULE_CGREPORT: false,
  MAIN_MENU_FUNCTIONS: cymbalMainMenuFunctions,
  CLINIC_INFO: {
    name: '信誠診所',
    code: '',
    address: '台北市大安區信義路四段197號',
    phone: '02-27068208'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Cymbal], 'tw'),
  PHARMACY_INFO: {
    name: '',
    address: '',
    phone: ''
  }
});
export var CymbalxinlinEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.Cymbalxinlin,
  BRANCH_ID: BranchID.Cymbalxinlin,
  BRANCH_CODE: 'K1nVvCSSv4a7',
  BOOKING_SOURCE_NAMES: ['simplybook_cymbalxinlin'],
  SUB_DOMAINS: ['cymbalxinlin', 'cymbalxinlin-staging'],
  BANNER_TITLE: '信霖門診',
  HEAD_TITLE: '信霖',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Cymbalxinlin]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', '抽血'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/cymbal_logo.png' : '/cymbal_logo.png',
  ENABLE_IMPORT_INBODY_DONGLE_DATA: true,
  ENABLE_MODULE_PHARMACY: false,
  ENABLE_MODULE_STOCK: false,
  ENABLE_MODULE_CGREPORT: false,
  MAIN_MENU_FUNCTIONS: cymbalMainMenuFunctions,
  CLINIC_INFO: {
    name: '信霖診所',
    code: '',
    address: '新竹市北區武陵路189號1-2樓',
    phone: '03-5326333'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Cymbalxinlin], 'tw'),
  PHARMACY_INFO: {
    name: '',
    address: '',
    phone: ''
  }
});
export var GenesisKHEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.GenesisKH,
  BRANCH_ID: BranchID.GenesisKH,
  BRANCH_CODE: 'v4vCSSa7K1nV',
  BOOKING_SOURCE_NAMES: ['simplybook_genesiskaohsiung'],
  SUB_DOMAINS: ['genesiskh', 'genesiskh-staging'],
  BANNER_TITLE: '高雄初日診所',
  HEAD_TITLE: '高雄初日診所',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.GenesisKH]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', 'CGM', '抽血', '注射', '點滴', '拿藥', '運動營養諮詢'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/genesis_staging_logo.png' : '/genesis_logo.png',
  MAIN_MENU_FUNCTIONS: [MainTitle.therapy].concat(clinicMainMenuFunctions),
  CLINIC_INFO: {
    name: '初日診所',
    code: '3507302019',
    address: '高雄市自由二路220號',
    phone: '07-5507551',
    region: '高雄',
    director: '李唐越'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.GenesisKH], 'tw'),
  PHARMACY_INFO: {
    name: '初日診所',
    address: '高雄市自由二路220號',
    phone: '07-5507551'
  },
  ORDER_SOURCES: [].concat(_toConsumableArray(DefaultClinic.ORDER_SOURCES), [OrderSource.pos]),
  VISIBLE_STORE_IDS: [StoreID.Cofit, StoreID.Genesis],
  STORE_ID: StoreID.Genesis,
  ENABLE_BOOKING_VIDEO_CALL: true
});
export var GenesisHCEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.GenesisHC,
  BRANCH_ID: 165,
  BRANCH_CODE: 'FdjRrUFDdsg53V',
  BOOKING_SOURCE_NAMES: ['simplybook_genesishsinchu'],
  SUB_DOMAINS: ['genesishc', 'genesishc-staging'],
  BANNER_TITLE: '新竹初日診所',
  HEAD_TITLE: '新竹初日診所',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.GenesisHC]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', 'CGM', '抽血', '注射', '點滴', '拿藥', '運動營養諮詢'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/genesis_staging_logo.png' : '/genesis_logo.png',
  MAIN_MENU_FUNCTIONS: [MainTitle.therapy].concat(clinicMainMenuFunctions),
  CLINIC_INFO: {
    name: '初日診所',
    code: '3512014437',
    address: '新竹市東區占梅路16號',
    phone: '03-5631788',
    region: '新竹',
    director: '魏士航'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.GenesisHC], 'tw'),
  PHARMACY_INFO: {
    name: '初日診所',
    address: '新竹市東區占梅路16號',
    pharmacist: '唐如意',
    phone: '03-5631788'
  },
  ORDER_SOURCES: [].concat(_toConsumableArray(DefaultClinic.ORDER_SOURCES), [OrderSource.pos]),
  VISIBLE_STORE_IDS: [StoreID.Cofit, StoreID.Genesis],
  STORE_ID: StoreID.Genesis,
  ENABLE_BOOKING_VIDEO_CALL: true
});
export var LumezGenesisEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.LumezGenesis,
  BRANCH_ID: 164,
  BRANCH_CODE: 'BlbljvBjotop',
  BOOKING_SOURCE_NAMES: ['simplybook_lumezgenesis'],
  SUB_DOMAINS: ['lumezgenesis', 'lumezgenesis-staging'],
  BANNER_TITLE: '小宙初日北屯',
  HEAD_TITLE: '小宙醫學',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.LumezGenesis]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', 'CGM', '抽血', '注射', '點滴', '拿藥', '運動營養諮詢'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/lumez_staging_logo.png' : '/lumez_logo.png',
  CLINIC_INFO: {
    name: '崇德小宙診所',
    code: '3503291284',
    address: '臺中市北屯區梅川東路五段131號3樓',
    phone: '',
    region: '北屯',
    director: '吳榛槿'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.LumezGenesis], 'tw'),
  PHARMACY_INFO: {
    pharmacist: '',
    name: '長幼藥局',
    address: '台中市北屯區崇德二路二段157號',
    phone: '04-22426767'
  }
});
export var TianyiEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  COUNTRY: 'cn',
  ORG_ID: OrgID.Tianyi,
  BRANCH_ID: BranchID.Tianyi,
  BRANCH_CODE: 'tianyi_genesis_clinic',
  APP_NAME: 'procn_app',
  APP_SOURCE: 'cofit',
  BOOKING_SOURCE_NAMES: ['kuaiyuyue_tianyi_genesis_clinic'],
  BOOKING_SOURCE_TYPE: '快预约',
  MAX_IDENTITY_LENGTH: 18,
  RECORD_NUMBER_PREFIX_FORMAT: 'YYYYMMDD',
  USE_ALIYUN: true,
  SITE_WISE_ENABLE_SENTRY: false,
  SUB_DOMAINS: ['tianyigenesis', 'tianyigenesis-staging'],
  SURVEY_ID_LIST: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID],
  BANNER_TITLE: '天一',
  HEAD_TITLE: '天一诊所',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Tianyi]), ['护理', '药局', '运动营养咨询', '其他']),
  SERVICE_NAME_LIST: ['初诊', '回诊', 'CGM', '抽血', '注射', '点滴', '拿药', '运动营养咨询'],
  FAVICON_PATH: commonSettings.isStagingEnv ? '/genesis_staging_logo.png' : '/genesis_logo.png',
  MAIN_MENU_FUNCTIONS: [MainTitle.diagnosis, MainTitle.timeline, MainTitle.bloodSugar, MainTitle.clientQuestionnaire, MainTitle.bodyMass, MainTitle.inspectionReport, MainTitle.report3D, MainTitle.abdominalUltrasound, MainTitle.uploadFile, MainTitle.ordersList],
  CLINIC_INFO: {
    name: '天一诊所',
    code: '天一诊所门诊代码',
    address: '',
    phone: ''
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Tianyi], 'cn'),
  ALLOW_FETCH_SOAP_BRANCHES: [BranchID.Tianyi],
  PHARMACY_INFO: {
    name: '',
    address: '',
    phone: ''
  }
}); // staging clinic

export var TestingEnvVariables = _objectSpread(_objectSpread({}, DefaultClinic), {}, {
  ORG_ID: OrgID.Testing,
  BRANCH_ID: BranchID.Genesis,
  BRANCH_CODE: 'VMVTRF2rrwoj',
  BOOKING_SOURCE_NAMES: ['simplybook_genesisclinic'],
  SUB_DOMAINS: ['corona', 'localhost'],
  BANNER_TITLE: '測試門診',
  HEAD_TITLE: 'TEST',
  PROVIDER_LIST: [].concat(_toConsumableArray(doctorListByBranch[OrgID.Testing]), commonProviderList),
  SERVICE_NAME_LIST: ['初診', '回診', 'CGM', '抽血', '注射', '點滴', '拿藥', '運動營養諮詢'],
  FAVICON_PATH: '/test_logo.png',
  CLINIC_INFO: {
    name: 'TEST門診',
    code: 'TEST門診代碼',
    address: '104台北市中山區松江路363號11樓',
    phone: '02-25075993'
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Testing], 'tw'),
  PHARMACY_INFO: {
    name: '台北初日診所',
    address: '台北市中山區民生東路2段163號3樓',
    phone: '02-25075661'
  },
  ORDER_SOURCES: [].concat(_toConsumableArray(DefaultClinic.ORDER_SOURCES), [OrderSource.pos]),
  VISIBLE_STORE_IDS: [StoreID.Cofit, StoreID.Genesis]
}); // consult

export var CofitEnvVariables = _objectSpread(_objectSpread({}, DefaultConsult), {}, {
  ORG_ID: OrgID.Cofit,
  BRANCH_ID: BranchID.Cofit,
  BRANCH_CODE: 'd6E4YQyp3kEL',
  BOOKING_SOURCE_NAMES: [].concat(_toConsumableArray(!commonSettings.isProductionEnv ? commonSettings.STAGING_BOOKING_SOURCE_NAMES : []), ['simplybook_cofit', 'simplybook_cofitservice', 'simplybook_cofitglobal', 'simplybook_nutritionanalysis']),
  SUB_DOMAINS: ['hq', 'hq-staging'],
  HEAD_TITLE: 'Cofit',
  BANNER_TITLE: 'Cofit',
  PROVIDER_LIST: ['線上', '總部', '台南', '高雄馨蕙馨', '台中小宙'],
  SERVICE_NAME_LIST: ['體態', '保健', '回診'],
  FAVICON_PATH: '/cofit-icon.webp',
  SOAP_RESPONSIBLER: RoleType.CLINIC_DIETICIAN_ROLE,
  CLINIC_INFO: {
    name: 'Cofit',
    code: '',
    address: '',
    phone: ''
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.Cofit], 'tw'),
  ALLOW_FETCH_SOAP_BRANCHES: [BranchID.Cofit],
  ORDER_SOURCES: [].concat(_toConsumableArray(DefaultConsult.ORDER_SOURCES), [OrderSource.pos]),
  VISIBLE_STORE_IDS: [StoreID.Cofit],
  STORE_ID: StoreID.Cofit
});
export var FCLabEnvVariables = _objectSpread(_objectSpread({}, DefaultConsult), {}, {
  ORG_ID: OrgID.FCLab,
  BRANCH_ID: BranchID.FCLab,
  BRANCH_CODE: 'd6E4YQyp3kFC',
  BOOKING_SOURCE_NAMES: ['simplybook_fclab'],
  SUB_DOMAINS: ['fclab', 'fclab-staging'],
  BANNER_TITLE: '脂研室',
  HEAD_TITLE: '脂研室',
  PROVIDER_LIST: ['線上', '總部', '台南', '高雄馨蕙馨', '台中小宙'],
  SERVICE_NAME_LIST: ['體態', '保健', '回診'],
  FAVICON_PATH: '/cofit-icon.webp',
  CLINIC_INFO: {
    name: '脂研室',
    code: '',
    address: '',
    phone: ''
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.FCLab], 'tw'),
  ALLOW_FETCH_SOAP_BRANCHES: [BranchID.FCLab],
  ENABLE_BOOKING_LINE_STATUS: false,
  ENABLE_BOOKING_PROVIDER: false,
  ENABLE_BOOKING_VIDEO_CALL: false
});
export var YouCofitHQEnvVariables = _objectSpread(_objectSpread({}, DefaultConsult), {}, {
  COUNTRY: 'cn',
  ORG_ID: OrgID.YouCofitHQ,
  BRANCH_ID: BranchID.YouCofitHQ,
  BRANCH_CODE: 'DFrwTrg45Dtd',
  APP_NAME: 'procn_app',
  APP_SOURCE: 'cofit',
  BOOKING_SOURCE_NAMES: ['kuaiyuyue_youcofit'],
  BOOKING_SOURCE_TYPE: '快预约',
  MAX_IDENTITY_LENGTH: 18,
  RECORD_NUMBER_PREFIX_FORMAT: 'YYYYMMDD',
  USE_ALIYUN: true,
  SUB_DOMAINS: ['cnhq', 'cnhq-staging'],
  SURVEY_ID_LIST: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID],
  BANNER_TITLE: '优可飞',
  HEAD_TITLE: '优可飞',
  PROVIDER_LIST: ['线上', '总部'],
  SERVICE_NAME_LIST: ['体态', '保健', '回诊'],
  FAVICON_PATH: '/cofit-icon.webp',
  CLINIC_INFO: {
    name: 'China Consult',
    code: '',
    address: '',
    phone: ''
  },

  /** @deprecated use hook `useUserByRole` instead */
  DOCTOR_LIST: getDoctorList(doctorListByBranch[OrgID.YouCofitHQ], 'cn'),
  ALLOW_FETCH_SOAP_BRANCHES: [BranchID.YouCofitHQ],
  ENABLE_BOOKING_LINE_STATUS: false,
  ENABLE_BOOKING_PROVIDER: false,
  ENABLE_BOOKING_VIDEO_CALL: false
});
export var AuFaitEnvVariables = _objectSpread(_objectSpread({}, DefaultBranchSetting), {}, {
  ORG_TYPE: ORG_TYPE.CONSULT,
  SURVEY_ID_LIST: [SurveyType.INIT_SURVEY_ID, SurveyType.HORMONES_SURVEY_ID],
  MEMO_CATEGORY_LIST: [MemoCategoryKey.booking_note, MemoCategoryKey.return_appointment_info_handover, MemoCategoryKey.client_info_detail, MemoCategoryKey.feedback_from_satisfactory_survey, MemoCategoryKey.personalized_supplement_assistant, MemoCategoryKey.one_on_one_consultation, MemoCategoryKey.personalized_supplement_consultation],
  BODYMASS_INIT_TYPE: BodyMassSource.all,
  ENABLE_SEARCH_USERS: true,
  ENABLE_IMPORT_INBODY_DONGLE_DATA: false,
  ENABLE_PRESETGROUP: false,
  ENABLE_MODULE_PHARMACY: false,
  ENABLE_MODULE_STOCK: false,
  ENABLE_MODULE_CGREPORT: false,
  ENABLE_MODULE_CLIENT_PROFILE: false,
  ENABLE_MODULE_INFO_MANAGEMENT: false,
  ENABLE_MODULE_MEASUREMENT_MANAGEMENT: false,
  ENABLE_DISPLAY_LINK_TO_POS: false,
  ENABLE_BOOKING_PRINCIPAL_COLUMN_FILTER: true,
  ENABLE_BOOKING_PRINCIPAL_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_SERVICE_NAME_GENERATE_FILTER_OPTIONS_BY_VALUES: true,
  ENABLE_BOOKING_LINE_STATUS: false,
  ENABLE_BOOKING_PROVIDER: false,
  ENABLE_BOOKING_VIDEO_CALL: false,
  ENABLE_BOOKING_EDIT: false,
  ENABLE_BOOKING_CREATE: true,

  /** @deprecated not use */
  ENABLE_BOOKING_PROVIDER_FILTER_CREATABLE: true,
  ENABLE_SURVEY_SHORT_NAME: true,
  ENABLE_FORMAT_CHATROOM_NAME_ON_PERSONAL_ROOM: true,
  ENABLE_SHOW_ANALYSIS_GUIDE: false,
  HIDE_SUMMARIZE_BUTTON: true,

  /** @deprecated use `SOAP_TYPES` instead */
  SOAP_KINDS: [SOAP_KINDS.RD],
  MAIN_MENU_FUNCTIONS: [MainTitle.diagnosis, MainTitle.timeline, MainTitle.clientQuestionnaire, MainTitle.bodyMass, MainTitle.uploadFile, MainTitle.ordersList],
  SOAP_RESPONSIBLER: RoleType.CLINIC_DIETICIAN_ROLE,
  SOAP_TYPES: [SoapType.NUTRITIONAL_CONSULTATION],
  ORG_ID: OrgID.AuFait,
  BRANCH_ID: BranchID.AuFait,
  BRANCH_CODE: 'aufait',
  BOOKING_SOURCE_NAMES: ['his_aufait'],
  SUB_DOMAINS: ['aufait', 'aufait-staging'],
  BANNER_TITLE: '吾霏醫美',
  HEAD_TITLE: '吾霏醫美',
  FETCH_PROVIDER_BY_ROLES: [RoleType.CLINIC_DIETICIAN_ROLE],
  PROVIDER_LIST: [],
  SERVICE_NAME_LIST: [{
    name: 'CoFait 體驗14天',
    duration: 30
  }, {
    name: 'CoFait 啟動21天',
    duration: 30
  }, {
    name: 'CoFait 極致21天',
    duration: 30
  }],
  FAVICON_PATH: '/logo/aufait-logo.webp',
  CLINIC_INFO: {
    name: '吾霏醫美',
    code: '',
    address: '',
    phone: '',
    region: '',
    director: ''
  },
  PHARMACY_INFO: {
    pharmacist: '',
    name: '',
    address: '',
    phone: ''
  },
  ALLOW_FETCH_SOAP_BRANCHES: [BranchID.AuFait],
  ORDER_SOURCES: [OrderSource.group_class],
  REGISTRATION_FORM_ID: 3303,
  VISIBLE_STORE_IDS: []
});
export var mapOrgIDsFromBranchIDs = function mapOrgIDsFromBranchIDs() {
  var branchIDs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return branchIDs.map(function (branchID) {
    var _branchInfo$ORG_ID;

    var branchInfo = getBranchInfoFromBranchID(branchID);
    return (_branchInfo$ORG_ID = branchInfo === null || branchInfo === void 0 ? void 0 : branchInfo.ORG_ID) !== null && _branchInfo$ORG_ID !== void 0 ? _branchInfo$ORG_ID : OrgID.Testing;
  });
};